import {
  PROVIDER_PLAN_CHANGE_VALUES,
} from '@/store/constants/mutationTypes';

import apiClient from '@shared/lib/general/apiClient';

const actions = {
  changeProviderPlanValues({ commit }, payload) {
    commit({
      type: PROVIDER_PLAN_CHANGE_VALUES,
      changes: payload,
    });
  },
  async getProviderServices({ dispatch }, payload) {
    const {
      corpId,
    } = payload;

    const { data } = await apiClient({
      method: 'GET',
      url: `/provider/plans/services/corp/${corpId}`,
    });

    dispatch('changeProviderPlanValues', [{
      field: 'services',
      value: data,
    }]);
  },
  async getProviderPlans({ dispatch }, payload) {
    const {
      corpId,
    } = payload;

    const { data } = await apiClient({
      method: 'GET',
      url: `/provider/plans/corp/${corpId}/all`,
    });

    dispatch('changeProviderPlanValues', [{
      field: 'plans',
      value: data,
    }]);
  },
  async createNewService({ dispatch, state }, service) {
    const {
      services,
    } = state;

    const { data } = await apiClient({
      method: 'POST',
      url: '/provider/plans/services/new',
      data: service,
    });

    const newServices = [
      ...services,
      data,
    ];

    dispatch('changeProviderPlanValues', [{
      field: 'services',
      value: newServices,
    }]);
  },
  async createNewPlan({ dispatch, state, rootState }, plan) {
    const {
      plans,
    } = state;

    const {
      disclaimer,
      services,
      ...newPlan
    } = plan;

    let createServices = [];
    services.forEach((s) => {
      if (!s.serviceId) {
        createServices.push({
          service: s.service,
          planType: s.planType,
          corpId: plan.corpId,
        });
      }
    });

    let newServices = services;

    if (createServices.length > 0) {
      const { data: createdServices } = await apiClient({
        method: 'POST',
        url: '/provider/plans/services/new/list',
        data: createServices,
      });
      createServices = createdServices;
    }

    newServices = services.map((service, idx) => {
      let { serviceId } = service;
      if (!serviceId && createServices.length > 0) {
        createServices.forEach((s) => {
          if (s.service === service.service) {
            const createdServiceId = s.serviceId;
            serviceId = createdServiceId;
          }
        });
      }
      return {
        ...service,
        serviceId,
        sortOrder: idx + 1,
      };
    });

    newPlan.services = newServices;
    
    const { data } = await apiClient({
      method: 'POST',
      url: '/provider/plans/new',
      data: newPlan,
    });

    const newPlans = [
      ...plans,
      data,
    ];

    const updateSettings = [{
      settingName: 'PLAN_DISCLAIMER',
      settingValue: disclaimer,
      corpId: plan.corpId,
    }];

    await apiClient({
      method: 'POST',
      url: '/partner/settings/set',
      data: updateSettings,
    });

    dispatch('changeProviderPlanValues', [{
      field: 'plans',
      value: newPlans,
    }]);
    dispatch('changeAdminValues', [{
      field: 'appOnly',
      value: plan.planType === 'AppOnly',
    }]);
    if (rootState.partnerDetail?.partnerSettings) {
      const newPSettings = {
        ...rootState.partnerDetail.partnerSettings,
        PLAN_DISCLAIMER: disclaimer,
      };
      dispatch('changePartnerDetailValues', [{
        field: 'partnerSettings',
        value: newPSettings,
      }]);
    } else {
      const newSettings = {
        ...rootState.setting.partnerSettings,
        PLAN_DISCLAIMER: disclaimer,
      };
      dispatch('changeSettingValues', [{
        field: 'partnerSettings',
        value: newSettings,
      }]);
    }
  },
  async updatePlanStatus({ dispatch, state, rootState }, updatePlan) {
    const {
      plans,
    } = state;
    const {
      setting: {
        partnerSettings,
      },
    } = rootState;
    const updated = await apiClient({
      method: 'PUT',
      url: `/provider/plans/${updatePlan.planId}/update`,
      data: updatePlan,
    });
    const updateSettings = [{
      settingName: 'PLAN_DISCLAIMER',
      settingValue: updatePlan.disclaimer,
      corpId: updatePlan.corpId,
    }];

    await apiClient({
      method: 'POST',
      url: '/partner/settings/set',
      data: updateSettings,
    });

    let newPlans = plans.slice();
    newPlans = newPlans.filter((plan) => plan.planId !== updatePlan.planId);
    if (updatePlan?.status?.toLowerCase() !== 'deleted') {
      const planFromApi = updated.data;
      if (updatePlan.signupBonusAccrual === null || updatePlan.SignupBonusAccrual === null) {
        planFromApi.signupBonusAccrual = null;
        planFromApi.SignupBonusAccrual = null;
      }
      newPlans.push(planFromApi);
    }
    dispatch('changeProviderPlanValues', [{
      field: 'plans',
      value: newPlans,
    }]);
    const newSettings = {
      ...partnerSettings,
      PLAN_DISCLAIMER: updatePlan.disclaimer,
    };
    dispatch('changeSettingValues', [{
      field: 'partnerSettings',
      value: newSettings,
    }]);
  },
};

export default actions;
